import React, { useMemo } from 'react';

import { useTranslation } from '@webtrader/core/i18n';

import CountryDialCodeDropdown from '@/components/CountryDialCodeDropdown';
import ValidationError from '@/components/FormValidationError';
import TextInput from '@/components/TextInput';

import { StyledLoginFormField } from '../styled';

interface ILoginOtpFormMobileInputProps {
  countryKey?: string;
  isError?: boolean;
  value?: string;
  onDialCodeChange?: (value: string | undefined) => void;
  onPhoneNumberChange?: (value: string | undefined) => void;
}

const LoginOtpFormMobileInput: FCC<ILoginOtpFormMobileInputProps> = (props) => {
  const { value, countryKey, isError = false, onPhoneNumberChange, onDialCodeChange } = props;
  const { t } = useTranslation();

  const handleDialCodeChange = (dialCode: string | number | undefined) => {
    let nextValue = dialCode;

    if (typeof nextValue === 'number') {
      nextValue = nextValue.toString();
    }

    onDialCodeChange?.(nextValue);
  };

  const validationText = useMemo(() => {
    if (!countryKey && value) {
      return t('Dial code is required');
    } else if (countryKey && value) {
      return t('Phone number is invalid');
    } else {
      return t('Phone number is required');
    }
  }, [countryKey, value, t]);

  return (
    <StyledLoginFormField>
      <TextInput
        label={t('Mobile Number')}
        keyboardType="number-pad"
        onlyNumeric={true}
        value={value}
        onChangeText={onPhoneNumberChange}
        prefix={
          <CountryDialCodeDropdown
            value={countryKey || t('Countries')}
            withBorder={false}
            onChange={handleDialCodeChange}
          />
        }
      />
      <ValidationError showValidation={isError} message={validationText} />
    </StyledLoginFormField>
  );
};

export default LoginOtpFormMobileInput;
